import React from 'react';
import { useDispatch } from 'react-redux';

import { goToMenu } from 'bento-ordering/cart/actions/orderSettings';
import Modal from 'bento-ordering/base/ui_components/Modal';
import GroupOrderJoinManager from 'bento-ordering/group_ordering/containers/GroupOrderJoinManager';

const GroupOrderJoinModal = () => {
  const dispatch = useDispatch();

  return (
    <Modal
      onClose={() => dispatch(goToMenu())}
      ariaLabel="Group Order Join form dialog"
      role="alertdialog"
    >
      <GroupOrderJoinManager />
    </Modal>
  );
};

export default GroupOrderJoinModal;
